import {
  FormCEPInput,
  FormInput,
  FormSelect,
  FormTextarea,
} from '@/components/ui/FormFields'
import { BRAZILIAN_STATES } from '@/constants/brazilianStates'
import {
  PropertiesContext,
  PropertiesContextType,
} from '@/contexts/PropertiesContext'
import { useStaysListingTypes } from '@/hooks/stays/useStaysListingTypes'
import { MultiLanguageString } from '@/lib/api/stays/types/shared-types'
import type {
  PropertyFormInput,
  PropertyFormOutput,
} from '@/schemas/propertySchema'
import { getLocalizedText } from '@/utils/getLocalizedText'
import { staysListingSubtypes } from '@/utils/property-utils'
import { SimpleGrid, VStack } from '@chakra-ui/react'
import { useContext } from 'react'
import { Control } from 'react-hook-form'

interface BasicInfoStepProps {
  control: Control<PropertyFormInput<boolean>, any, PropertyFormOutput<boolean>>
}

export function BasicInfoStep({ control }: BasicInfoStepProps) {
  const { selectedStaysProperty } = useContext<
    PropertiesContextType | undefined
  >(PropertiesContext) as PropertiesContextType
  const { stListingTypes } = useStaysListingTypes()
  return (
    <VStack spacing={6} align="stretch">
      {selectedStaysProperty && (
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
          <FormSelect
            name="listing_type"
            label="Tipo de Endereço/Anúncio"
            control={control}
            options={stListingTypes.map(({ stays_id, _mstitle }) => ({
              value: stays_id,
              label: getLocalizedText(
                (_mstitle as MultiLanguageString) ?? undefined
              ),
            }))}
            isRequired
          />

          <FormSelect
            name="subtype"
            label="Subtipo"
            control={control}
            options={staysListingSubtypes}
            isRequired
          />
        </SimpleGrid>
      )}
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
        <FormInput
          name="title"
          label="Título da Acomodação"
          control={control}
          isRequired
          placeholder="Ex: Apartamento Aconchegante no Centro"
        />

        <FormInput
          name="internalname"
          label="Referência Interna"
          control={control}
          isRequired
          placeholder="SOU 509B"
          textTransform="uppercase"
        />
      </SimpleGrid>

      <SimpleGrid
        columns={{ base: 1, md: 3 }}
        gridTemplateColumns={'2fr 1fr 1.5fr'}
        spacing={4}
      >
        <FormInput
          name="address.street"
          label="Logradouro"
          control={control}
          isRequired
          placeholder="Rua das flores"
        />

        <FormInput
          name="address.streetNumber"
          label="Número"
          control={control}
          isRequired
          placeholder="15908"
        />

        <FormInput
          name="address.region"
          label="Bairro"
          control={control}
          isRequired
          placeholder="Perdizes"
        />
      </SimpleGrid>

      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4}>
        <FormInput
          name="address.city"
          label="Cidade"
          control={control}
          isRequired
          placeholder="São Paulo"
        />

        <FormSelect
          name="address.stateCode"
          label="Estado"
          control={control}
          options={BRAZILIAN_STATES.map((s) => ({ ...s }))}
          isRequired
        />

        <FormCEPInput
          name="address.zip"
          label="CEP"
          control={control}
          isRequired
        />
      </SimpleGrid>

      <FormTextarea
        name="description"
        label="Descrição (Opcional)"
        control={control}
        placeholder="Descreva as características especiais da acomodação..."
        tooltip="Para uma melhor performance do anúncio é recomendavel uma descrição de no mínimo 400 caracteres"
        rows={3}
      />
    </VStack>
  )
}
